// extracted by mini-css-extract-plugin
export default {"AddContent":"styles_AddContent__Hbd9c"};